
  export default {
'block' : { 

 typeTheme :{ 
 'storeSubmitContainer' : { 
  'bottom' : '60px'
 
}} 
}
,
'button' : { 

 typeTheme :{ 
 'swtichAccount' : { 
  'line-height' : '30px'
 
}} 
}

}